import { RCCallout } from '@reverbdotcom/cadence/components';
import React from 'react';
import I18n from 'i18n-js';
import { InfoIcon } from '@reverbdotcom/cadence/icons/react';

export default function BillingMethodNeededBanner() {

  return (
    <RCCallout
      themeType="utility"
      variant="info-ultralight"
      icon={<InfoIcon />}
      title={I18n.t('discovery.payStatement.billingMethodNeededBanner.headline')}
    >
      <p>{I18n.t('discovery.payStatement.billingMethodNeededBanner.message')}</p>
    </RCCallout>
  );
}
